<template>
    <div>
      <Breadcrumb :breadcrumbList="breadcrumbList" />
      <div class="content-header px-0">
        <h1 class="title-I">Editar Notificação</h1>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card direct-chat direct-chat-primary employee">
            <div class="card-body">
              <div class="pt-4 pr-4 pb-2 pl-4 bg-white rounded">
                <div class="row mb-2">
                  <div class="col-12">
                    <div class="card direct-chat direct-chat-primary">
                      <div class="card-body custom-card overflow-visible">
                        <div class="p-4 bg-white rounded">
                          <form @submit.prevent="updateAlert" novalidate="true">
                            <div class="row">
                              <TwInput label="Classe" required="false">
                                <select
                                  id="classe"
                                  class="form-control"
                                  v-model="alertObj.class_"
                                >
                                  <option
                                    v-for="(classe, index) in classes"
                                    :key="index"
                                    :value="classe.name"
                                  >
                                    {{classe.name}}
                                  </option>
                                </select>
                              </TwInput>
                              <TwInput
                                label="Código - Tipo de Alerta"
                                required="false"
                              >
                                <input
                                  type="number"
                                  v-model="alertObj.code"
                                  class="form-control"
                                  placeholder="Código"
                                  id="codigo"
                                />
                              </TwInput>
                              <TwInput
                                label="Mensagem associada à notificação"
                                required="false"
                              >
                                <input
                                  type="text"
                                  v-model="alertObj.msg"
                                  class="form-control"
                                  placeholder="Mensagem"
                                  id="mensagem"
                                />
                              </TwInput>
                            </div>
                            <div class="row p-1">
                              <button
                                id="updateAlert"
                                type="submit"
                                class="btn btn-primary px-5"
                                :disabled="load"
                              >
                                <i
                                  v-if="load"
                                  class="fas fa-sync-alt fa-spin"
                                ></i>
                                Atualizar
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import TwInput from "@/components/TwInput.vue";
  import Breadcrumb from "../../components/Breadcrumb.vue";
  import "./style.scss";
  export default {
    name: "EditAlert",
    data() {
      return {
        breadcrumbList: [],
        
        alertObj: {
          
          class_: "",
          code: null,
          msg: "",
        },
      };
    },
    mounted() {
      this.updateList();
      this.$store.dispatch("alert/getById", this.$route.params.notificationId);
      this.$store.dispatch("alert/getAlertsClasses");
    },
    watch: {
      alert(newAlert) {
        if (newAlert.length) {        
          this.alertObj = {
          id: newAlert[0].id,
          class_: newAlert[0].class_, 
          code: newAlert[0].code,
          msg: newAlert[0].msg,
          }; 
        }
      },
    },
    methods: {
      updateList() {
        this.breadcrumbList = this.$route.meta.breadcrumb;
      },
      validateAlert() {
        if (!this.alertObj.class_ || this.alertObj.class_.trim() === "") {
          window.frontMsg("FRNT_EMPTY_WARNING", { field: "Classe" });
          return false;
        }
        if (!this.alertObj.code || this.alertObj.code <= 0) {
          window.frontMsg("FRNT_EMPTY_WARNING", {
            field: "Código - Tipo de Alerta",
          });
          return false;
        }
        if (!this.alertObj.msg || this.alertObj.msg.trim() === "") {
          window.frontMsg("FRNT_EMPTY_WARNING", {
            field: "Mensagem associada à notificação",
          });
          return false;
        }
        return true;
      },
      updateAlert() {
        if (this.validateAlert()) {
          this.$store.dispatch("alert/putAlert", this.alertObj);
          this.$router.push("/notification")
        }   
      },
    },
    components: {
      Breadcrumb,
      TwInput,
    },
    computed: {
      load() {
        return this.$store.getters["load"];
      },
      classes() {
        return this.$store.getters["alert/classes"];
      },
      alert() {
        return this.$store.getters["alert/alert"];
      },
    },
  };
  </script>